import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';

export default function ArticleDetail() {
  const { slug } = useParams<{ slug: string }>();
  const article = articles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <>
        <Navbar />
        <div className="min-h-screen flex items-center justify-center pt-16">
          <div className="text-center">
            <h1 className="font-heading text-4xl font-bold text-foreground-950 mb-4">爆料不存在</h1>
            <p className="text-foreground-500 mb-6">这个瓜还没熟，先看看别的吧~</p>
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-arrow-left-line"></i> 返回首页
            </Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  const relatedArticles = articles
    .filter((a) => a.id !== article.id && a.category === article.category)
    .slice(0, 3);

  const dateStr = new Date(article.published_at).toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  const viewsStr = article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views.toString();

  return (
    <>
      <Navbar />

      <article className="pt-20 pb-14">
        {/* Article Header */}
        <header className="max-w-3xl mx-auto px-4 md:px-6 pt-8 pb-10">
          <div className="flex items-center gap-3 mb-4 flex-wrap">
            <Link
              to={`/category/${article.category}`}
              className="px-3 py-1 rounded-full text-xs font-semibold bg-primary-100 text-primary-700 hover:bg-primary-200 transition-colors whitespace-nowrap"
            >
              {article.categoryName}
            </Link>
            {article.is_featured && (
              <span className="px-3 py-1 rounded-full text-xs font-semibold bg-accent-100 text-accent-800 whitespace-nowrap">
                独家爆料
              </span>
            )}
            {article.is_hot && (
              <span className="px-3 py-1 rounded-full text-xs font-semibold bg-secondary-100 text-secondary-700 whitespace-nowrap">
                热门
              </span>
            )}
          </div>

          <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight mb-4">
            {article.title}
          </h1>

          <div className="flex items-center gap-4 text-sm text-foreground-500 flex-wrap">
            <span className="flex items-center gap-1.5">
              <i className="ri-user-line"></i>
              {article.author}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-calendar-line"></i>
              {dateStr}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-eye-line"></i>
              {viewsStr} 阅读
            </span>
          </div>
        </header>

        {/* Cover Image */}
        <div className="max-w-3xl mx-auto px-4 md:px-6 mb-10">
          <div className="w-full h-[400px] md:h-[500px] rounded-xl overflow-hidden">
            <img
              src={article.cover_image}
              alt={article.title}
              title={`${article.title} - 吃瓜爆料`}
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Article Content */}
        <div className="max-w-2xl mx-auto px-4 md:px-6">
          <div className="article-content" dangerouslySetInnerHTML={{ __html: article.content }} />

          {/* Tags */}
          <div className="mt-10 pt-8 border-t border-background-200">
            <div className="flex items-center gap-2 flex-wrap">
              <span className="text-sm text-foreground-500 mr-1">标签：</span>
              {article.tags.map((tag) => (
                <Link
                  key={tag}
                  to={`/tag/${encodeURIComponent(tag)}`}
                  className="px-3 py-1.5 rounded-full text-sm bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-700 transition-colors whitespace-nowrap"
                >
                  #{tag}
                </Link>
              ))}
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <section className="max-w-2xl mx-auto px-4 md:px-6 mt-14 text-center">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            这个瓜够大吗？
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mb-8">
            还想看更多猛料？关注吃瓜爆料网，每日更新不重样！
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full text-base font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            获取更多爆料
            <i className="ri-arrow-right-line"></i>
          </Link>
        </section>

        {/* Related Articles */}
        {relatedArticles.length > 0 && (
          <section className="max-w-7xl mx-auto px-4 md:px-6 mt-20">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-8">相关爆料</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {relatedArticles.map((a) => (
                <ArticleCard key={a.id} {...a} />
              ))}
            </div>
          </section>
        )}
      </article>

      <Footer />
    </>
  );
}
